import { createSelector, Selector } from "reselect";
import { RootState } from "../../store";

export const metadataSelector: Selector<RootState, RootState["metadata"]> = state => state.metadata;

export const badgePrintFormatSelector = createSelector(metadataSelector, metadata => metadata.badgePrintFormat);

export const offlineSelector = createSelector(metadataSelector, metadata => metadata.offline);

export const colocatedShowDataSyncVisibleSelector = createSelector(metadataSelector, metadata => metadata.colocatedShowDataSyncVisible);

export const colocatedShowDataSyncStatusSelector = createSelector(metadataSelector, metadata => metadata.colocatedShowDataSyncStatus);

export const colocatedShowDataSyncProgressSelector = createSelector(metadataSelector, metadata => metadata.colocatedShowDataSyncProgress);
